import React from "react";
import "./userItem.less";
import { Icon_Person } from "../../../BP2Components/Icons/icons";

const UserItem = ({ value, title, showTitle }) => {
   if (title === "-" || title === null || title === "") return null;
   return (
      <div className="gx-product-body-user">
         <p className="p1 avdertisement-item-body__title">
            <Icon_Person fill="#8c8c8c" />
            {showTitle === true && <b>{title}: </b>}
            {value}
         </p>
      </div>
   );
};

export default UserItem;
